var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30468 18.1016C4.57968 18.1016 4 17.5133 4 16.7883V3.41485C4 2.68984 4.57968 2.10156 5.30468 2.10156H12.4579C13.1829 2.10156 13.7712 2.68984 13.7712 3.41485V16.7883C13.7712 17.5133 13.1829 18.1016 12.4579 18.1016H5.30468ZM7.77569 17.0062H9.99609C10.2656 17.0062 10.4797 16.7922 10.4797 16.5226C10.4797 16.2531 10.2656 16.0305 9.99609 16.0305H7.77569C7.50615 16.0305 7.28351 16.2531 7.28351 16.5226C7.28351 16.7922 7.50617 17.0062 7.77569 17.0062Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.1fcb58873a6c5273b482bb54989a3ce0.svg";
export { ForwardRef as ReactComponent };